import cityMap from '../data/city-zip.json';

function getCityFromZip(zip: string): string {
  const city = cityMap?.find((el) => el.zip === zip)?.cityName || '';
  return city;
}

export default getCityFromZip;
